import { Result, ok, err } from "neverthrow";
import { ParseError } from "../../shared/errors/parseError";
import {
  HttpLostFound,
  HttpLostFoundListResponse,
  ILostFoundsCollectionParser,
} from "../bbsRepository.types";
import { injectable } from "inversify";
import {
  ILostFound,
  ILostFoundsCollection,
} from "@/domain/entities/bbs/lostFound/lostFound.types";
import { LostFoundTypeCode } from "@/types";
import dayjs from "dayjs";

function parseLostFound(data: HttpLostFound): ILostFound {
  const lostFound: ILostFound = {
    type: data.lostTs ? LostFoundTypeCode.Lost : LostFoundTypeCode.Found,
    uid: data.uid,
    title: data.title,
    lostNote: data.lostNote,
    allocUid: data.allocUid,
    lineName: data.lineName,
    lineRouteNo: data.lineRouteNo,
    lineRouteName: data.lineRouteName,
    statusCode: data.statusCode,
    statusName: data.statusName,
    foundTs: data.foundTs
      ? dayjs(data.foundTs).format("YYYY-MM-DD HH:mm")
      : undefined,
    lostTs: data.lostTs
      ? dayjs(data.lostTs).format("YYYY-MM-DD HH:mm")
      : undefined,
    statusTs: dayjs(data.statusTs).format("YYYY-MM-DD HH:mm:ss"),
    createdTs: dayjs(data.createdTs).format("YYYY-MM-DD HH:mm:ss"),
    createdUid: data.createdUid,
    updatedTs: data.updatedTs
      ? dayjs(data.updatedTs).format("YYYY-MM-DD HH:mm:ss")
      : undefined,
    savedTs: dayjs(data.savedTs).format("YYYY-MM-DD HH:mm:ss"),
  };
  return lostFound;
}

@injectable()
export class LostFoundsCollectionParser implements ILostFoundsCollectionParser {
  constructor() {}

  toDomain(
    response: HttpLostFoundListResponse
  ): Result<ILostFoundsCollection, ParseError> {
    try {
      const totalCount = response.totalCount;
      const lostFoundList = response.data.map(parseLostFound);
      const lostFoundsCollection: ILostFoundsCollection = {
        list: lostFoundList,
        totalCount: totalCount ?? 0,
      };
      return ok(lostFoundsCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
